/* TELAPERSONALIZZATA NATIVE GIFT WRAP v1 */
document.addEventListener('DOMContentLoaded', () => {
  const box = document.querySelector('[data-tp-gift-addon]');
  if (!box) return;
  const toggle = box.querySelector('[data-tp-gift-toggle]');
  const status = box.querySelector('[data-tp-gift-status]');
  const messageInput = box.querySelector('[data-tp-gift-message]');
  const variantId = Number(box.dataset.variantId || 0);
  let lineKey = box.dataset.lineKey || '';
  let busy = false;

  const setBusy = (v, msg='') => {
    busy = v;
    toggle.disabled = v;
    box.classList.toggle('is-loading', v);
    if (status) status.textContent = msg;
  };

  toggle.addEventListener('change', async () => {
    if (busy) return;
    const want = toggle.checked;
    setBusy(true, want ? 'Aggiungo…' : 'Rimuovo…');
    try {
      if (want) {
        if (!variantId) throw new Error('Variante confezione regalo non disponibile');
        const properties = {'_tp_addon':'gift'};
        const message = messageInput ? messageInput.value.trim() : '';
        if (message) properties.Bigliettino = message;
        const r = await fetch('/cart/add.js', {
          method: 'POST', headers: {'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({items:[{id:variantId, quantity:1, properties}]})
        });
        if (!r.ok) throw new Error('Impossibile aggiungere la confezione regalo');
      } else {
        if (!lineKey) {
          const cart = await fetch('/cart.js').then(r=>r.json());
          const gift = cart.items.find(i => i.handle === 'gift-wrap');
          lineKey = gift ? gift.key : '';
        }
        if (lineKey) {
          const r = await fetch('/cart/change.js', {
            method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
            body: JSON.stringify({id:lineKey, quantity:0})
          });
          if (!r.ok) throw new Error('Impossibile rimuovere la confezione regalo');
        }
      }
      window.location.reload();
    } catch (e) {
      console.error(e);
      toggle.checked = !want;
      setBusy(false, 'Riprova tra qualche secondo');
    }
  });
});
